(function () {

    "use strict";

    angular
        .module('userActivation')
        .controller("EmailVerificationModal", EmailVerificationModal);

    EmailVerificationModal.$inject = ['$scope', 'onClose', '$stateParams', '$state', 'userActivationService', '$filter'];

    function EmailVerificationModal($scope, onClose, $stateParams, $state, userActivationService, $filter) {
        var self = this;

        self.whenVerificationFinished = function ($event) {
            if ($event.verified) {
                self.close();
            }
        };

        self.close = function () {
            onClose && onClose();
            $scope.$hide();
        };

        self.save = function () {
        };

    }

})();
